import { auth } from "@/service/auth";
import store from "@/store";
export function requireAuth(to: any, from: any, next: any) {
  let _auth = new auth();
  if (!_auth.loggedIn()) {
    goLoginPage(to, next);
  } else {
    if (store.getters["Authentication/timerRefeshToken"] == null) {
      _auth.checkAuthen().then((isAuth: any) => {
        if (isAuth) {
          _auth.refreshToken();
          store.dispatch(
            "Authentication/setTimerRefeshToken",
            _auth.timerRefreshToken
          );
          next();
        } else {
          goLoginPage(to, next);
        }
      }, (err: any) => {
        goLoginPage(to, next);
      }
    );
    } else {
      next();
    }
  } 
}

function goLoginPage(to: any, next: any) {
  let loginName = to.meta + "login";
  next({
    name: loginName,
    query: { redirect: to.fullPath }
  });
}
